import 'css-chunksrc/client/scenes/workloads/wbs/loader/styles.scss';export default {
  "loader": "_loader_xjtsh_1",
  "projectElement": "_projectElement_xjtsh_5"
};